import {Modal} from "@shop/frontend/web/js/components/Modal";
import {helpers} from "@shop/frontend/web/js/helpers";

export class EventView {
	constructor() {
		this.$popupModal = null;
		this.$placesContainer = $("#js-places");
		this.modal = new Modal({className: "i-modal_mobile-fixed", id: "popup-event"});
		this.modalAlert = new Modal({className: "i-modal_alert", id: "alert-modal"});
		this.$stadium = $("#js-stadium");
	}

	getPlacesSettings() {
		const settings = {};

		if (this.$placesContainer.attr("data-show-free-places") === "0")
			settings.showFreePlaces = false;
		if (this.$placesContainer.attr("data-price-filter-type"))
			settings.planPriceFilterType = parseInt(
				this.$placesContainer.attr("data-price-filter-type")
			);
		if (this.$placesContainer.attr("data-has-child-ticket") === "true") {
			settings.hasChildTicket = true
		}

		return settings;
	}

	showEventOnPopup() {
		let places = $("#js-places");
		const htmlObject = document.createElement("div");
		htmlObject.innerHTML = places.appendTo("<div></div>").html();
		this.modal.show(htmlObject);
		this.$popupModal = $(".i-modal_mobile-fixed");
		this.$popupModal.find(".places__content").wrap("<div id='js-places'></div>");
		this.$popupModal.find(".places__top").show();

		this.$popupModal.find(".places__middle").append($(".js-stadium-zones"));
		this.$popupModal.find(".places__middle").append($(".js-places-prices"));

		this.modal.on("hide", () => window.location.assign("/"));
	}

	returnEventFromPopup() {
		$(".events_page").after($("#js-places"));

		$("#js-places-check-price").after($(".js-stadium-zones"));
		$("#js-places-check-price").after($(".js-places-prices"));

		$(".places__top").hide();
		this.$popupModal.find(".modal-body").html("");
		this.$popupModal.removeClass("i-modal_mobile-fixed");
		this.$popupModal.modal("hide");
	}

	showChildTicketInfo() {
		if (!localStorage.getItem("change_price_id_alert")) {
			const isSeason = $(".events_page").data("is-season");
			const word = isSeason ? "абонемент" : "билет";
			this.modalAlert.show(
				`
					<h3>Обратите внимание!</h3>
					<p class="mb-0">Доступен ${word} для детей от 7 до 14 лет с 50% скидкой, приобрести его можно только в паре с обычным. </p>
					<label class="checkbox mt-4 mb-4 d-inline-flex">
              <input type="checkbox" name="show_price_id_alert_discount" class="checkbox__input" checked />
              <span class="checkbox__custom"></span>
              <span class="checkbox__block">Не показывать это сообщение</span>
          </label>
          <br>
          <button class="btn js-price-id-alert-btn" data-bs-dismiss="modal">Продолжить</button>
				`
			);

			$(".js-price-id-alert-btn").on("click", () => {
				if ($("input[name='show_price_id_alert_discount']").is(":checked")) {
					localStorage.setItem("change_price_id_alert", "true");
				}
			});
		}
	}

	showStadium() {
		$(document).on("mouseover", e => {
			const element = $(e.target);
			if (element.closest("#svg").length || element.closest(".stadium").length) {
				if (helpers.isDesktop.matches) {
					const activeSector = $(element).closest("g[view_id]");
					if (activeSector.length) {
						const view = activeSector.attr("view_id");
						if(view){
							this.addImageToStadium(view);
							this.setCords();
							this.$stadium.addClass("active");
						}
					}
				}
			} else {
				this.$stadium.removeClass("active");
			}
		});

		this.addStadium()
	}

	addStadium() {
		this.setCords();

		$(document).on("scroll", () => {
			this.setCords();
		});
	}

	setCords() {
		this.$stadiumPlace = $("#js-stadium-place");

		if (!this.$stadiumPlace[0]) {
			return false;
		}

		const size = this.$stadiumPlace[0].getBoundingClientRect();
		this.stadiumHeight = size.height;
		this.stadiumWidth = size.width;
		const stadiumTop = size.top;
		const stadiumLeft = size.left;
		this.$stadium.css("width", this.stadiumWidth);
		this.$stadium.css("height", this.stadiumHeight);
		this.$stadium.css("top", stadiumTop);
		this.$stadium.css("left", stadiumLeft);
	}

	addImageToStadium(view) {
		this.$stadium
			.css("background-image", "url(/images/stadium/" + view + ".png)")
			.addClass("active");
	}
}
